
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

function requireEnv(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(`Missing ${name} — defina em .env / Netlify env (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY)`);
  }
  return value;
}

const SUPABASE_URL = requireEnv('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL);
const SUPABASE_PUBLISHABLE_KEY = requireEnv('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY);

// Export constants for external use
export { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY };
export const SUPABASE_ANON_KEY = SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

type NetworkErrorDetail = {
  message: string;
  endpoint: string;
};

const dispatchNetworkError = (detail: NetworkErrorDetail) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent<NetworkErrorDetail>('supabase:network-error', { detail }));
  }
};

const supabaseFetch: typeof fetch = async (input, init) => {
  try {
    return await fetch(input, init);
  } catch (error) {
    const isNetworkError =
      error instanceof TypeError &&
      (error.message?.includes('Failed to fetch') || error.message?.includes('proxy'));

    if (!isNetworkError) {
      throw error;
    }

    const endpoint = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
    dispatchNetworkError({
      message: 'Não foi possível conectar ao Supabase. Verifique sua conexão ou configuração de proxy.',
      endpoint,
    });

    return new Response(
      JSON.stringify({
        error: {
          message: 'SUPABASE_NETWORK_ERROR',
          details: error.message,
        },
        data: null,
      }),
      {
        status: 503,
        statusText: 'Supabase Network Error',
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }
};

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      fetch: supabaseFetch,
    },
  }
);
